export enum EmployeeReviewCategories {
    general = 1,
    bidding = 2,
    revenue = 3,
    employeeEval = 4
}